import { isDefined } from "@omni/utils/helper.utils";
import { ReactNode } from "react";

import {
    Items,
    ResultsContextProvider
} from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { useResultsPanelContext } from "@/components/Search/SearchBar/components/ResultsPanel/context/resultsPanel.context";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";

type Props = {
    children: ReactNode;
};

export const Base = ({ children }: Props) => {
    const { isOpen, items, autocompleteState, autocompleteActions } =
        useSearchBarContext();

    const { showResults } = useResultsPanelContext();

    if (
        !showResults ||
        !isOpen ||
        !isDefined(items) ||
        !isDefined(autocompleteState) ||
        !isDefined(autocompleteActions)
    ) {
        return null;
    }

    return (
        <ResultsContextProvider items={items as Items}>
            {children}
        </ResultsContextProvider>
    );
};
